import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-feature-row',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './feature-row.html',
  styleUrl: './feature-row.scss',
})
export class FeatureRow {
  @Input() heading: string = '';
  @Input() headingLevel: 'h2' | 'h3' = 'h2';

  /** One or more paragraphs shown below the heading. */
  @Input() paragraphs: string[] = [];

  /** Bullet items shown below the paragraphs (omit for no list). */
  @Input() listItems: string[] = [];

  /** 'plain' = default browser bullet <ul>; 'check' = checkmark-icon rows; 'none' = no list. */
  @Input() listStyle: 'none' | 'plain' | 'check' = 'none';

  /** Only relevant when listStyle="check". */
  @Input() checkIconSize: 'sm' | 'lg' = 'lg';

  /** Only relevant when listStyle="check". Splits the checklist into 2 columns (desktop breakpoints only). */
  @Input() checklistColumns: 1 | 2 = 1;

  @Input() image: string = '';
  @Input() imageAlt: string = '';
  @Input() imagePosition: 'left' | 'right' = 'right';

  /** Escape hatch for one-off inline overrides (e.g. "box-shadow: none"). */
  @Input() imageStyle: string = '';

  /** CTA link shown below the content (omit for no button). */
  @Input() buttonLabel: string = '';
  @Input() buttonLink: string | any[] = '';
  @Input() buttonQueryParams: Record<string, any> | null = null;
  @Input() buttonIcon: boolean = true;
}
